// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeScreen__switchWrapper___guhad {
    position: relative;
}

.HomeScreen__switchWrapper___guhad > div {
    position: absolute;
}

.HomeScreen__homeBody___RsTlO {
    display: flex;
    padding: 5vw;
    padding-top: 15vh;
    flex-direction: column;
    overflow-x: hidden;
    align-self: center;
    align-items: center;
}

.HomeScreen__link___GQ4CK {
    color: #6060FF;
    text-decoration: none;
}

.HomeScreen__link2___K033I {
    color: #ffffff
}

.HomeScreen__link___GQ4CK:hover {
    text-decoration: underline;
}

@media screen and (min-width: 1100px) {
    .HomeScreen__sectionContainer___iWwXj {
        width: 100vw;
        padding-top: 10vw;
        padding-bottom: 10vw;
        display: flex;
        height: 40vh;
    }

    .HomeScreen__section___tybEL {
        width: 80%;
        margin-left: 10vw;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .HomeScreen__headerSection___vS4pi {
        justify-content: space-between;
    }

    .HomeScreen__socialIcon___LUKUz {
        font-size: 1.25vw;
        color: var(--black)
    }

    .HomeScreen__img___kD2cd {
        width: 14vw;
        height: 20vw;
        border-radius: 1vw;
        margin: 0.5vw;
        object-fit: cover;
        align-self: flex-start;
    }

    .HomeScreen__opacity___nkARh {
        position: absolute;
        width: 100vw;
        height: 120%;
        top: 0;
        background: rgba(0, 0, 0, 0.4);
    }

    .HomeScreen__box___UWwXD {
        width: 25vw;
        height: 65vh;
        padding-top: 5vh;
        align-items: center;
        display: flex;
        flex-direction: column;
        position: fixed;
        top: 30%;
        left: 50%;
        transform: translate(-50%, -30%);
        background: white;
        border-radius: 1vw;
    }

    .HomeScreen__icon___IYpNP {
        width: 5vw;
        height: 5vw;
        border-radius: 1.25vw;
        margin-top: 4vh;
    }

    .HomeScreen__stiiick___YzUof {
        width: 10vw;
        height: 2.5vw;
        object-fit: contain;
        margin-top: 6vh;
    }

    .HomeScreen__title___MeIAc {
        font-size: 3vw;
        color: #ffffff;
        font-weight: bold;
    }

    .HomeScreen__subtitle___qNj_H {
        font-size: 1.3vw;
        margin-top: 3vh;
        color: #FFFFFF;
        text-align: left;
        line-height: 1.5;
    }

    .HomeScreen__heading___BVphA {
        font-size: 2.5vw;
        font-weight: bold;
    }

    .HomeScreen__description___WVzgh {
        font-size: 1.2vw;
        margin-top: 3vh;
        color: #FFFFFF;
        text-align: left;
        line-height: 1.5;
    }

    .HomeScreen__subDescription___MD2og {
        margin-top: 1vh;
    }

    .HomeScreen__description2___v6tU0 {
        color: var(--black);
        font-size: 1vw;
        width: 90%
    }

    .HomeScreen__store___cRk7b {
        width: 10vw;
        height: 3.33vw;
        border: 1px solid #FFFFFF;
        border-radius: 10px;
    }

    .HomeScreen__storeContainer___LOUM2 {
        margin-top: 5vh;
    }

    .HomeScreen__tbr___AktVn {
        font-size: 1vw;
        margin-top: 4vh;
        font-weight: bold;
        white-space: nowrap;
    }

    .HomeScreen__demo___TcVhB {
        font-size: 1vw;
        color: #6060FF;
        transition: 0.5s;
    }

    .HomeScreen__demoButton___x3Tz_ {
        border: 1px solid #6060FF;
        border-radius: 2vw;
        margin-top: 2.5vh;
        padding: 0.5vw;
        text-decoration: none;
        transition: 0.5s;
    }

    .HomeScreen__demoButton___x3Tz_:hover {
        background: #6060FF;
    }

    .HomeScreen__demoButton___x3Tz_:hover .HomeScreen__demo___TcVhB {
        color: #ffffff;
    }

    .HomeScreen__footer___GpKOp {
        position: fixed;
        bottom: 0;
        /*bottom: 20vh;*/
        width: 100vw;
        height: 5vh;
        display: flex;
        /*z-index: 3;*/
        justify-content: center;
        align-items: center;
        background: #ffffff;
        /*width: 45%;*/
    }

    .HomeScreen__footerItem___NrXAn {
        color: var(--black);
        font-size: 0.75vw;
        white-space: nowrap;
    }

    .HomeScreen__fCont___IaOhf {
        padding-left: 0.5vw;
        padding-right: 0.5vw;
        text-decoration: none;
        flex-direction: row;
    }

    .HomeScreen__fCont___IaOhf:hover {
        text-decoration: underline;
    }

    .HomeScreen__copyright___FEvhq {
        padding-left: 0.5vw;
        padding-right: 0.5vw;
    }

}


@media screen and (max-width: 1100px) {
    .HomeScreen__sectionContainer___iWwXj {
        width: 100vw;
        padding-top: 10vw;
        padding-bottom: 10vw;
        display: flex;
        height: 80vh;
    }

    .HomeScreen__section___tybEL {
        width: 90%;
        margin-left: 5vw;
        display: flex;
        position: relative;
        flex-direction: column;
        padding-top: 5vh;
    }

    .HomeScreen__opacity___nkARh {
        position: absolute;
        width: 100vw;
        height: 50vw;
        /*top: 95vh;*/
        background: rgba(0, 0, 0, 0.2);
    }

    .HomeScreen__imagesContainer___Rwrbm {
        padding-left: 4vw;
        padding-right: 4vw;
        height: 50vw;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: center;
        overflow-y: hidden;
        /*position: fixed;*/
        background: #ffffff;
    }


    .HomeScreen__icon___IYpNP {
        width: 20vw;
        height: 20vw;
        border-radius: 5vw;
        margin-top: 4vh;
    }

    .HomeScreen__iconOpacity___jU2jE {
        position: absolute;
        margin-top: 15vw;
    }

    .HomeScreen__stiiick___YzUof {
        width: 43vw;
        height: 15vw;
        margin-top: 5vh;
        object-fit: contain;
    }

    .HomeScreen__title___MeIAc {
        font-size: 8vw;
        margin-top: 2vh;
        color: #ffffff;
        font-weight: bold;
    }

    .HomeScreen__heading___BVphA {
        font-size: 7vw;
        font-weight: bold;
    }

    .HomeScreen__description___WVzgh {
        font-size: 5vw;
        margin-top: 5vh;
        color: #FFFFFF;
        text-align: left;
        line-height: 1.5;
    }

    .HomeScreen__subDescription___MD2og {
        margin-top: 2vh;
    }

    .HomeScreen__description2___v6tU0 {
        color: var(--black);
        font-size: 4.5vw;
        /*width: 90%*/
    }

    .HomeScreen__store___cRk7b {
        width: 40vw;
        height: 13.3vw;
        border: 1px solid #FFFFFF;
        border-radius: 10px;
    }

    .HomeScreen__storeContainer___LOUM2 {
        margin-top: 7vh;
        justify-content: space-around;
        display: flex;
    }

    .HomeScreen__mobileStoreBtn___xrSu_ {
        /*margin-bottom: 5vh;*/
    }

    .HomeScreen__img___kD2cd {
        width: 14vw;
        height: 20vw;
        border-radius: 1vw;
        margin: 0.5vw;
        object-fit: cover;
        align-self: flex-start;
    }

    footer {
        position: relative;
        /*z-index: -1;*/
        height: 20vh;
        background: rgb(18, 18, 23);
        font-size: 0.72vw;
    }

    .HomeScreen__footerContainer___uf_g3 {
        position: fixed;
        bottom: 2vh;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        width: 100%;

    }

    .HomeScreen__footerItem___NrXAn {
        text-align: center;
        margin-top: 2vh;
        color: white;
        font-size: 3vw;
        text-decoration: none;
    }

    .HomeScreen__tbrContainer___FJOgW {
        /*z-index: 20;*/
        margin-top: 3vh;
    }

    .HomeScreen__tbr___AktVn {
        font-size: 4.5vw;
        margin-top: 4vh;
        text-align: center;
        font-weight: bold;
        white-space: nowrap;
    }

    .HomeScreen__demo___TcVhB {
        font-size: 4.5vw;
        text-align: center;
        color: #6060FF;
    }

    .HomeScreen__demoButton___x3Tz_ {
        border: 1px solid #6060FF;
        border-radius: 6vw;
        margin-top: 4vh;
        text-decoration: none;
        padding: 2vw;
    }

    .HomeScreen__tableContainer___V4Imm {
        overflow: auto;
        display: flex;
    }

    .HomeScreen__tableWrapper___K9ESr {
        padding-left: 5vw;
        padding-right: 5vw;
    }


}

.HomeScreen__iii___Ak7kW {
    color: #6060FF;
}

.HomeScreen__learn___plHIO {
    font-size: 4.5vw;
    margin-top: 2vh;
    color: #6060FF;
    text-decoration: underline;
}

@keyframes HomeScreen__Gradient___cDegP {
    0% {
        background-position: 0% 50%
    }
    50% {
        background-position: 100% 50%
    }
    100% {
        background-position: 0% 50%
    }
}





`, "",{"version":3,"sources":["webpack://./src/website/HomeScreen/HomeScreen.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,YAAY;QACZ,iBAAiB;QACjB,oBAAoB;QACpB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,iBAAiB;QACjB,aAAa;QACb,mBAAmB;QACnB,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,aAAa;QACb,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,MAAM;QACN,8BAA8B;IAClC;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,mBAAmB;QACnB,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,QAAQ;QACR,SAAS;QACT,gCAAgC;QAChC,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,qBAAqB;QACrB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,cAAc;QACd,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,cAAc;QACd,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd;IACJ;;IAEA;QACI,WAAW;QACX,cAAc;QACd,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,iBAAiB;QACjB,cAAc;QACd,qBAAqB;QACrB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,SAAS;QACT,gBAAgB;QAChB,YAAY;QACZ,WAAW;QACX,aAAa;QACb,cAAc;QACd,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;QACpB,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;AAEJ;;;AAGA;IACI;QACI,YAAY;QACZ,iBAAiB;QACjB,oBAAoB;QACpB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,aAAa;QACb,kBAAkB;QAClB,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,aAAa;QACb,8BAA8B;IAClC;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,eAAe;QACf,uBAAuB;QACvB,uBAAuB;QACvB,kBAAkB;QAClB,mBAAmB;QACnB,mBAAmB;IACvB;;;IAGA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,cAAc;QACd,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,cAAc;QACd,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,6BAA6B;QAC7B,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,aAAa;QACb,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,YAAY;QACZ,2BAA2B;QAC3B,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,6BAA6B;QAC7B,WAAW;;IAEf;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,YAAY;QACZ,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,kBAAkB;QAClB,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,eAAe;QACf,qBAAqB;QACrB,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;;AAGJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;AACJ","sourcesContent":[".switchWrapper {\n    position: relative;\n}\n\n.switchWrapper > div {\n    position: absolute;\n}\n\n.homeBody {\n    display: flex;\n    padding: 5vw;\n    padding-top: 15vh;\n    flex-direction: column;\n    overflow-x: hidden;\n    align-self: center;\n    align-items: center;\n}\n\n.link {\n    color: #6060FF;\n    text-decoration: none;\n}\n\n.link2 {\n    color: #ffffff\n}\n\n.link:hover {\n    text-decoration: underline;\n}\n\n@media screen and (min-width: 1100px) {\n    .sectionContainer {\n        width: 100vw;\n        padding-top: 10vw;\n        padding-bottom: 10vw;\n        display: flex;\n        height: 40vh;\n    }\n\n    .section {\n        width: 80%;\n        margin-left: 10vw;\n        display: flex;\n        flex-direction: row;\n        justify-content: space-evenly;\n    }\n\n    .headerSection {\n        justify-content: space-between;\n    }\n\n    .socialIcon {\n        font-size: 1.25vw;\n        color: var(--black)\n    }\n\n    .img {\n        width: 14vw;\n        height: 20vw;\n        border-radius: 1vw;\n        margin: 0.5vw;\n        object-fit: cover;\n        align-self: flex-start;\n    }\n\n    .opacity {\n        position: absolute;\n        width: 100vw;\n        height: 120%;\n        top: 0;\n        background: rgba(0, 0, 0, 0.4);\n    }\n\n    .box {\n        width: 25vw;\n        height: 65vh;\n        padding-top: 5vh;\n        align-items: center;\n        display: flex;\n        flex-direction: column;\n        position: fixed;\n        top: 30%;\n        left: 50%;\n        transform: translate(-50%, -30%);\n        background: white;\n        border-radius: 1vw;\n    }\n\n    .icon {\n        width: 5vw;\n        height: 5vw;\n        border-radius: 1.25vw;\n        margin-top: 4vh;\n    }\n\n    .stiiick {\n        width: 10vw;\n        height: 2.5vw;\n        object-fit: contain;\n        margin-top: 6vh;\n    }\n\n    .title {\n        font-size: 3vw;\n        color: #ffffff;\n        font-weight: bold;\n    }\n\n    .subtitle {\n        font-size: 1.3vw;\n        margin-top: 3vh;\n        color: #FFFFFF;\n        text-align: left;\n        line-height: 1.5;\n    }\n\n    .heading {\n        font-size: 2.5vw;\n        font-weight: bold;\n    }\n\n    .description {\n        font-size: 1.2vw;\n        margin-top: 3vh;\n        color: #FFFFFF;\n        text-align: left;\n        line-height: 1.5;\n    }\n\n    .subDescription {\n        margin-top: 1vh;\n    }\n\n    .description2 {\n        color: var(--black);\n        font-size: 1vw;\n        width: 90%\n    }\n\n    .store {\n        width: 10vw;\n        height: 3.33vw;\n        border: 1px solid #FFFFFF;\n        border-radius: 10px;\n    }\n\n    .storeContainer {\n        margin-top: 5vh;\n    }\n\n    .tbr {\n        font-size: 1vw;\n        margin-top: 4vh;\n        font-weight: bold;\n        white-space: nowrap;\n    }\n\n    .demo {\n        font-size: 1vw;\n        color: #6060FF;\n        transition: 0.5s;\n    }\n\n    .demoButton {\n        border: 1px solid #6060FF;\n        border-radius: 2vw;\n        margin-top: 2.5vh;\n        padding: 0.5vw;\n        text-decoration: none;\n        transition: 0.5s;\n    }\n\n    .demoButton:hover {\n        background: #6060FF;\n    }\n\n    .demoButton:hover .demo {\n        color: #ffffff;\n    }\n\n    .footer {\n        position: fixed;\n        bottom: 0;\n        /*bottom: 20vh;*/\n        width: 100vw;\n        height: 5vh;\n        display: flex;\n        /*z-index: 3;*/\n        justify-content: center;\n        align-items: center;\n        background: #ffffff;\n        /*width: 45%;*/\n    }\n\n    .footerItem {\n        color: var(--black);\n        font-size: 0.75vw;\n        white-space: nowrap;\n    }\n\n    .fCont {\n        padding-left: 0.5vw;\n        padding-right: 0.5vw;\n        text-decoration: none;\n        flex-direction: row;\n    }\n\n    .fCont:hover {\n        text-decoration: underline;\n    }\n\n    .copyright {\n        padding-left: 0.5vw;\n        padding-right: 0.5vw;\n    }\n\n}\n\n\n@media screen and (max-width: 1100px) {\n    .sectionContainer {\n        width: 100vw;\n        padding-top: 10vw;\n        padding-bottom: 10vw;\n        display: flex;\n        height: 80vh;\n    }\n\n    .section {\n        width: 90%;\n        margin-left: 5vw;\n        display: flex;\n        position: relative;\n        flex-direction: column;\n        padding-top: 5vh;\n    }\n\n    .opacity {\n        position: absolute;\n        width: 100vw;\n        height: 50vw;\n        /*top: 95vh;*/\n        background: rgba(0, 0, 0, 0.2);\n    }\n\n    .imagesContainer {\n        padding-left: 4vw;\n        padding-right: 4vw;\n        height: 50vw;\n        display: flex;\n        flex-wrap: wrap;\n        align-items: flex-start;\n        justify-content: center;\n        overflow-y: hidden;\n        /*position: fixed;*/\n        background: #ffffff;\n    }\n\n\n    .icon {\n        width: 20vw;\n        height: 20vw;\n        border-radius: 5vw;\n        margin-top: 4vh;\n    }\n\n    .iconOpacity {\n        position: absolute;\n        margin-top: 15vw;\n    }\n\n    .stiiick {\n        width: 43vw;\n        height: 15vw;\n        margin-top: 5vh;\n        object-fit: contain;\n    }\n\n    .title {\n        font-size: 8vw;\n        margin-top: 2vh;\n        color: #ffffff;\n        font-weight: bold;\n    }\n\n    .heading {\n        font-size: 7vw;\n        font-weight: bold;\n    }\n\n    .description {\n        font-size: 5vw;\n        margin-top: 5vh;\n        color: #FFFFFF;\n        text-align: left;\n        line-height: 1.5;\n    }\n\n    .subDescription {\n        margin-top: 2vh;\n    }\n\n    .description2 {\n        color: var(--black);\n        font-size: 4.5vw;\n        /*width: 90%*/\n    }\n\n    .store {\n        width: 40vw;\n        height: 13.3vw;\n        border: 1px solid #FFFFFF;\n        border-radius: 10px;\n    }\n\n    .storeContainer {\n        margin-top: 7vh;\n        justify-content: space-around;\n        display: flex;\n    }\n\n    .mobileStoreBtn {\n        /*margin-bottom: 5vh;*/\n    }\n\n    .img {\n        width: 14vw;\n        height: 20vw;\n        border-radius: 1vw;\n        margin: 0.5vw;\n        object-fit: cover;\n        align-self: flex-start;\n    }\n\n    footer {\n        position: relative;\n        /*z-index: -1;*/\n        height: 20vh;\n        background: rgb(18, 18, 23);\n        font-size: 0.72vw;\n    }\n\n    .footerContainer {\n        position: fixed;\n        bottom: 2vh;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-around;\n        width: 100%;\n\n    }\n\n    .footerItem {\n        text-align: center;\n        margin-top: 2vh;\n        color: white;\n        font-size: 3vw;\n        text-decoration: none;\n    }\n\n    .tbrContainer {\n        /*z-index: 20;*/\n        margin-top: 3vh;\n    }\n\n    .tbr {\n        font-size: 4.5vw;\n        margin-top: 4vh;\n        text-align: center;\n        font-weight: bold;\n        white-space: nowrap;\n    }\n\n    .demo {\n        font-size: 4.5vw;\n        text-align: center;\n        color: #6060FF;\n    }\n\n    .demoButton {\n        border: 1px solid #6060FF;\n        border-radius: 6vw;\n        margin-top: 4vh;\n        text-decoration: none;\n        padding: 2vw;\n    }\n\n    .tableContainer {\n        overflow: auto;\n        display: flex;\n    }\n\n    .tableWrapper {\n        padding-left: 5vw;\n        padding-right: 5vw;\n    }\n\n\n}\n\n.iii {\n    color: #6060FF;\n}\n\n.learn {\n    font-size: 4.5vw;\n    margin-top: 2vh;\n    color: #6060FF;\n    text-decoration: underline;\n}\n\n@keyframes Gradient {\n    0% {\n        background-position: 0% 50%\n    }\n    50% {\n        background-position: 100% 50%\n    }\n    100% {\n        background-position: 0% 50%\n    }\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switchWrapper": `HomeScreen__switchWrapper___guhad`,
	"homeBody": `HomeScreen__homeBody___RsTlO`,
	"link": `HomeScreen__link___GQ4CK`,
	"link2": `HomeScreen__link2___K033I`,
	"sectionContainer": `HomeScreen__sectionContainer___iWwXj`,
	"section": `HomeScreen__section___tybEL`,
	"headerSection": `HomeScreen__headerSection___vS4pi`,
	"socialIcon": `HomeScreen__socialIcon___LUKUz`,
	"img": `HomeScreen__img___kD2cd`,
	"opacity": `HomeScreen__opacity___nkARh`,
	"box": `HomeScreen__box___UWwXD`,
	"icon": `HomeScreen__icon___IYpNP`,
	"stiiick": `HomeScreen__stiiick___YzUof`,
	"title": `HomeScreen__title___MeIAc`,
	"subtitle": `HomeScreen__subtitle___qNj_H`,
	"heading": `HomeScreen__heading___BVphA`,
	"description": `HomeScreen__description___WVzgh`,
	"subDescription": `HomeScreen__subDescription___MD2og`,
	"description2": `HomeScreen__description2___v6tU0`,
	"store": `HomeScreen__store___cRk7b`,
	"storeContainer": `HomeScreen__storeContainer___LOUM2`,
	"tbr": `HomeScreen__tbr___AktVn`,
	"demo": `HomeScreen__demo___TcVhB`,
	"demoButton": `HomeScreen__demoButton___x3Tz_`,
	"footer": `HomeScreen__footer___GpKOp`,
	"footerItem": `HomeScreen__footerItem___NrXAn`,
	"fCont": `HomeScreen__fCont___IaOhf`,
	"copyright": `HomeScreen__copyright___FEvhq`,
	"imagesContainer": `HomeScreen__imagesContainer___Rwrbm`,
	"iconOpacity": `HomeScreen__iconOpacity___jU2jE`,
	"mobileStoreBtn": `HomeScreen__mobileStoreBtn___xrSu_`,
	"footerContainer": `HomeScreen__footerContainer___uf_g3`,
	"tbrContainer": `HomeScreen__tbrContainer___FJOgW`,
	"tableContainer": `HomeScreen__tableContainer___V4Imm`,
	"tableWrapper": `HomeScreen__tableWrapper___K9ESr`,
	"iii": `HomeScreen__iii___Ak7kW`,
	"learn": `HomeScreen__learn___plHIO`,
	"Gradient": `HomeScreen__Gradient___cDegP`
};
export default ___CSS_LOADER_EXPORT___;
